import { Image } from '@/components/Image'
import { BodyM } from '@/components/Typography'
import type { TitleProps } from '@/models'
import type { BuilderImage } from '@/models/BuilderImage'

import { MediaCardHeading, MediaCardListItem, MediaCardListItemHeader } from './styles'

export interface MediaCardProps {
  image?: BuilderImage
  title?: TitleProps
  description?: TitleProps
}
const MediaCard = ({ image, title, description }: MediaCardProps) => (
  <MediaCardListItem>
    <MediaCardListItemHeader>
      {image && (
        <Image
          aria-hidden={image['aria-hidden']}
          source={image.url}
          alt={image.alt}
          width={48}
          height={48}
        />
      )}
      {title && <MediaCardHeading tag={title.tag || 'h4'}>{title.text}</MediaCardHeading>}
    </MediaCardListItemHeader>
    {description && <BodyM tag={description.tag || 'p'}>{description.text}</BodyM>}
  </MediaCardListItem>
)
export default MediaCard
